/* This whole file codes are inspired by the file set-a11y-status.js of downshift.
 * Reference: https://github.com/paypal/downshift
 */

/** a function to get a11y message */
function getA11yMessage(messgObject) {
  const {
    inputValue,
    itemsCount,
    itemSelected,
    open,
    suggestedText
  } = messgObject;
  if (!open) {
    return itemSelected ? inputValue : '';
  }

  if (!itemsCount) {
    return 'No results available.';
  }

  let a11yMessage = `${itemsCount} result${
    itemsCount === 1 ? '' : 's'
  } available, \
    use up or down arrow key to navigate, press Enter key to select.`;
  if (suggestedText) {
    a11yMessage += ` Suggested option is ${suggestedText}, press Tab key to select.`;
  }

  return a11yMessage;
}

let idsDtaA11yMssgDiv = document.getElementById(
  'idsDropdownTypeahead-a11y-message'
);

let idsDtaA11yMssgs = [];

/**
 * Create a sub child DOM node for holding the status message
 */
function getStatusChildDiv(message) {
  const childA11yMssgsDiv = document.createElement('div');
  childA11yMssgsDiv.textContent = message;
  return childA11yMssgsDiv;
}

/**
 * Create and/or return the DOM node for a11y status
 */
function getMessageDiv() {
  if (idsDtaA11yMssgDiv) {
    return idsDtaA11yMssgDiv;
  }

  idsDtaA11yMssgDiv = document.createElement('div');
  idsDtaA11yMssgDiv.setAttribute('id', 'idsDropdownTypeahead-a11y-message');
  idsDtaA11yMssgDiv.setAttribute('role', 'status');
  idsDtaA11yMssgDiv.setAttribute('aria-live', 'polite');
  idsDtaA11yMssgDiv.setAttribute('aria-relevant', 'additions text');
  Object.assign(idsDtaA11yMssgDiv.style, {
    border: '0',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    width: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute'
  });
  document.body.appendChild(idsDtaA11yMssgDiv);
  return idsDtaA11yMssgDiv;
}

/**
 * the function to set a11y status message.
 * Param: "status" typeof string
 */
function setA11yMessage(a11yMessage) {
  idsDtaA11yMssgs = [a11yMessage];
  const div = getMessageDiv();

  // Remove previous children if it exists
  while (div.lastChild) {
    div.removeChild(div.firstChild);
  }

  // filter Boolean for ignoring a falsy item
  idsDtaA11yMssgs.filter(Boolean).forEach(message => {
    div.appendChild(getStatusChildDiv(message));
  });
}

/**
 * the function to remove a11y status message.
 */
function cleanA11yMessage() {
  if (idsDtaA11yMssgDiv) {
    document.body.removeChild(idsDtaA11yMssgDiv);
    idsDtaA11yMssgDiv = null;
  }

  idsDtaA11yMssgs = [];
}

export { getA11yMessage, setA11yMessage, cleanA11yMessage };
